import AuthContext from 'context/AuthContext'
import useToastContext from 'hooks/useToastContext'
import { useContext, useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { generateRandomID } from 'utils/reusableMethods'

const LoginFromSmartfin = () => {
  const navigate = useNavigate()
  const notification = useToastContext();

  let { loginUserSmartfin } = useContext(AuthContext)

  const callApi = async () => {
    var login_id = new URLSearchParams(window.location.search).get('login_id');
    if (login_id == null || login_id.length === 0) {
      navigate('/login', { replace: true })
      return
    }

    let sendData = {
      login_id,
      device_id: generateRandomID(10),
      device_type: 'web',
      device_token: generateRandomID(20)
    }
    try {
      var res = await loginUserSmartfin(sendData)
      if (res.message) {
        notification.error(res.message);
        setTimeout(() => {
          navigate('/login', { replace: true })
        }, 2000)
        return
      }
      if (res.needsRegistration) {
        navigate('/register', { state: { prefilledFields: res.registrationData } })
        return
      }

      navigate("/dashboard")
    } catch (err) {}
  }

  useEffect(() => {
    callApi()
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <div className="w-full flex text-center justify-center h-full">
      <img src="images/whitelogo.svg" className="w-[20rem] md:w-[15rem] shimmerable shimmer-loading hidden dark:block" alt="ALPAY LOGO" />
      <img src="images/logo.svg" className="w-[20rem] md:w-[15rem] shimmerable shimmer-loading block dark:hidden" alt="ALPAY LOGO" />
    </div>
  );
}

export default LoginFromSmartfin
